import { ApolloProvider } from '@apollo/client'
import { ThemeProvider } from '@emotion/react'
import { AlertProvider, AlertConductor } from '@wolfdanepug/common-react'
import { Outlet } from 'react-router'
import { CssBaseline, Stack, Toolbar, Box } from '@mui/material'
import { AppProvider } from './context/app/AppContext'
import Header from './components/Header'
import theme from './theme'
import client from './graphql/client'
import { CartProvider } from './context/cart/CartContext'
import { DataProvider } from './context/data/DataContext'
import { OnboardingProvider } from './context/onboarding/OnboardingContext'

function App() {
	// default toolbar height
	const height = 110
	return (
		<ApolloProvider client={client}>
			<ThemeProvider theme={theme}>
				<AlertProvider>
					<CssBaseline />
					<AlertConductor placement="banner" />
					<AppProvider>
						<Header />
						<Stack
							sx={{
								minHeight: '100vh'
							}}
							spacing={0}
						>
							<Toolbar
								sx={{
									height: {
										xs: 80,
										md: height
									},
									transition: 'height 0.3s'
								}}
							/>
							<Box component={'main'} sx={styles.flex}>
								<CartProvider>
									<DataProvider>
										<OnboardingProvider>
											<Outlet />
										</OnboardingProvider>
									</DataProvider>
								</CartProvider>
							</Box>
						</Stack>
					</AppProvider>
				</AlertProvider>
			</ThemeProvider>
		</ApolloProvider>
	)
}

const styles = {
	flex: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column'
	}
}

export default App
